import { render, staticRenderFns } from "./MsgLeftItem.vue?vue&type=template&id=2db18219&"
import script from "./MsgLeftItem.vue?vue&type=script&lang=ts&"
export * from "./MsgLeftItem.vue?vue&type=script&lang=ts&"
import style0 from "./MsgLeftItem.vue?vue&type=style&index=0&id=2db18219&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports